import { useState } from "react";

// Use this to replace the content of pop up, and remain the heading
const ConfirmDelete = ({ itemName, deleteFunction, cancelFunction }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    console.log("clicked");
    setIsSubmitting(true);
    await deleteFunction();
    setIsSubmitting(false);
  };

  const handleCancel = async () => {
    setIsSubmitting(true);
    await cancelFunction();
    setIsSubmitting(false);
  };

  return (
    <div className="grid grid-cols-2 col-span-full row-span-full gap-y-2 gap-x-2 p-4 font-chinese">
      <p className="text-lg col-span-2">你確認要刪除{itemName}嗎？</p>
      <div className="col-start-2 flex gap-x-2">
        <button
          onClick={handleDelete}
          disabled={isSubmitting}
          className="bg-custom-red text-white rounded-full w-20 h-8 hover:brightness-75 disabled:opacity-70"
        >
          刪除
        </button>
        <button
          onClick={handleCancel}
          disabled={isSubmitting}
          className="bg-custom-gray text-white rounded-full w-20 h-8 hover:brightness-75 disabled:opacity-70"
        >
          取消
        </button>
      </div>
    </div>
  );
};

export default ConfirmDelete;
